export default __webpack_public_path__ + "static/media/logo_transparent.7f69f8f8.png";